import turf from 'turf'
require('@turf/distance')

export const distanceBetweenPointsInFt = ({ from, to }) => {
  return turf.distance(from, to) * 5280.8
}



// WEBPACK FOOTER //
// ./src/utils/pointDistance.js